import React from "react";
import "./Pagination.css";

const Pagination = ({ currentPage, totalItems, itemsPerPage = 20, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="pagination-container">
      <button
        onClick={handlePrevPage}
        disabled={currentPage === 1}
        className="pagination-btn"
      >
        Prev
      </button>

      <span className="pagination-info">
        Showing {(currentPage-1)*itemsPerPage+1} - {(currentPage*itemsPerPage) > totalItems ? totalItems : currentPage*itemsPerPage} Sensors from {totalItems}
      </span>

      <button
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        className="pagination-btn"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
